import React from 'react';
import SolutionScheduleContainer from 'containers/SolutionScheduleContainer/SolutionScheduleContainer';

export default function SolutionSchedulePage() {
    return (
        <SolutionScheduleContainer />
    )
}
